import { CollectiveUser } from 'graphql/generated'

export const getSearchableUser = (
  platformUser: Maybe<
    Pick<NonNullable<CollectiveUser['platformUser']>, 'displayName'>
  >,
  address: CollectiveUser['address']
) => `${platformUser?.displayName} ${address}`.toLocaleLowerCase()
